import users from './User/UserDetail';
import studentData from './StudentData/StudentData';
export const Reducers = {
  users,
  studentData,
};
